import init from 'letter-boxed-solver'
import * as wasm from 'letter-boxed-solver'

await init();

export default wasm